export default __webpack_public_path__ + "static/media/oguzhan4.ceaa6457.jpg";